import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SuggestedReportService {

  private apiUrl: string;
    
  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  getSuggestedReport(payload: (string | null) = null) {
    return this.http.get(
      // this.common.getBaseUrl() + 'patients.php?action=PatientsList' + (payload ? '&list=all' : '')
      this.apiUrl + '/suggested-report', this.getAuthHeaders()
    );
  }

  addSuggestedReport(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addPatients";
    // return this.http.post(this.common.getBaseUrl() + 'patients.php', payload);
    return this.http.post(this.apiUrl + '/suggested-report', payload, this.getAuthHeaders());
  }

  updateSuggestedReport(payload: any) {
    payload["action"] = "updatePatients";
    // return this.http.put(this.common.getBaseUrl() + 'patients.php', payload);
    return this.http.put(this.apiUrl + '/suggested-report/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteSuggestedReport(payload: any) {
    payload["action"] = "deletePatients";
    return this.http.put(this.apiUrl + '/suggested-report/' + payload.id, payload, this.getAuthHeaders());
  }
}
